var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneContact = function SvgPhoneContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.672 11.7a7.838 7.838 0 0 0 3.656 3.647.751.751 0 0 0 .74-.057l2.345-1.565a.741.741 0 0 1 .712-.066l4.387 1.884a.74.74 0 0 1 .45.779A4.5 4.5 0 0 1 16.5 20.25 12.75 12.75 0 0 1 3.75 7.5a4.5 4.5 0 0 1 3.928-4.463.74.74 0 0 1 .778.45l1.885 4.397a.75.75 0 0 1-.057.703L8.72 10.97a.75.75 0 0 0-.047.73Z"
  })));
};
export default SvgPhoneContact;